module.exports = __webpack_public_path__ + "img/testim5.aef624c7.webp";